<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">
      <el-form-item>
<!--        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="success" icon="el-icon-edit" :disabled="single" @click="handleUpdate">修改</el-button>-->
        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">删除</el-button>
      </el-form-item>
      <el-form-item label="用户昵称" prop="name">
        <el-input
          v-model="queryParams.nickname"
          placeholder="用户昵称内容"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="queryParams.sex" placeholder="请选择性别">
          <el-option label="女" value="2"></el-option>
          <el-option label="男" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="到期时间" prop="url">
        <el-date-picker
          v-model="queryParams.expireStartTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="到期时间"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="pageList" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" type="index" width="100" />
      <el-table-column label="用户昵称" prop="nickname" :show-overflow-tooltip="true" width="200" />
      <el-table-column label="头像" prop="avatar" :show-overflow-tooltip="true" width="250" >
        <template slot-scope="scope">
          <image-preview :src="scope.row.avatar" :width="50" :height="50"/>
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="status" :formatter="sexFormat" :show-overflow-tooltip="true" width="100" />
      <el-table-column label="到期时间" prop="expireDate" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >延长vip
          </el-button>
          <el-button
            v-if="scope.row.status==0"
            type="text"
            @click="handleStatusChange(scope.row)"
          >禁用
          </el-button>
          <el-button
            v-if="scope.row.status==1"
            type="text"
            @click="handleStatusChange(scope.row)"
          >启用
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="pagination.total>0"
      :total="pagination.total"
      :page.sync="pagination.current"
      :limit.sync="pagination.size"
      @pagination="handleQuery"
    />

    <!-- 添加或修改打招呼配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="到期时间">
          <el-date-picker
            v-model="form.expireDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="到期时间"
            clearable
            style="width: 240px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, detail, update, add, del,getList,patch } from '@/api/member/vip'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams: {
        name: undefined
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },
      // 菜单列表
      menuOptions: [],
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        content: [
          { required: true, message: '打招呼内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    sexFormat(row) {
      return row.sex === 1 ? '男' : '女'
    },
    statusFormat(row) {
      return row.status === 1 ? '禁用' : '使用中'
    },
    handleQuery() {
      this.queryParams.current = this.pagination.current
      this.queryParams.size = this.pagination.size
      this.queryParams.type = 2
      console.log(dayjs().format('YYYY-MM-DD HH:mm:ss'))
      this.queryParams.expireDate = dayjs().format('YYYY-MM-DD HH:mm:ss')
      getList(this.queryParams).then(response => {
        this.pageList = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        current: 1,
        size: 10,
        total: 0
      }
      this.queryParams = {
        name: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    handleStatusChange(row) {
      const text = row.status === 1 ? '启用' : '禁用'
      row.status = row.status === 1 ? 0 : 1
      this.$confirm('确认要"' + text + '"数据项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return patch(row.id, {status: row.status})
      }).then(() => {
        this.$message.success(text + '成功')
        this.handleQuery()
      }).catch(function () {

      })
    },
    handleAdd() {
      this.resetForm()
      this.dialog = {
        title: '新增打招呼',
        visible: true
      }
    },
    handleUpdate(row) {
      this.resetForm()
      this.dialog = {
        title: '修改打招呼',
        visible: true
      }
      const id = row.id || this.ids
      detail(id).then(response => {
        this.form = response.data
      })
    },
    handleDelete(row) {
      const ids = [row.id || this.ids].join(',')
      console.log(this.ids)
      this.$confirm('是否确认删除选中的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del(ids).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() =>
        this.$message.info('已取消删除')
      )
    },
    handleSubmit: function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const id = this.form.id
          if (id != undefined) {
            update(this.form.id, this.form).then(() => {
              this.$message.success('修改成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          } else {
            add(this.form).then(() => {
              this.$message.success('新增成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        id: undefined,
        name: undefined,
        url: undefined
      }
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    }
  }
}
</script>
